import { Box } from '@interstate/components/Box';
import { Button } from '@interstate/components/Button';
import { Typography } from '@interstate/components/Typography';
import { ChevronDownIcon, ChevronRightIcon } from '@interstate/components/Icons';
import { PencilSquareIcon } from '@interstate/components/Icons/PencilSquareIcon';

type TradesHeaderProps = {
    isExpanded: boolean;
    onToggleExpanded: () => void;
    onEdit: () => void;
    hasTradeIns: boolean;
};

const TradesHeader = ({ isExpanded, onToggleExpanded, onEdit, hasTradeIns }: TradesHeaderProps) => {
    return (
        <Box
            m={-1}
            p={1}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                cursor: hasTradeIns ? 'pointer' : 'default'
            }}
            onClick={hasTradeIns ? onToggleExpanded : undefined}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.3rem',
                    cursor: hasTradeIns ? 'pointer' : 'default'
                }}
            >
                <Box width="13px">
                    {hasTradeIns && (isExpanded ? <ChevronDownIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />)}
                </Box>
                <Typography variant="body-xs">Trades</Typography>
            </Box>
            <Button
                data-testid="trades-edit-button"
                buttonStyle="tertiary"
                size="aux"
                startIcon={<PencilSquareIcon />}
                onClick={(e) => {
                    e.stopPropagation();
                    onEdit();
                }}
            >
                Edit
            </Button>
        </Box>
    );
};

export default TradesHeader;
